import { Button, Flex, Image, Text } from "@chakra-ui/react"
import { withPrefix } from "gatsby"
import React from "react"
import { useTranslation } from "react-i18next"
import { useVNZAuthentication } from "../hooks/useVNZAuthentication"
import { useVNZAuthenticationState } from "../hooks/useVNZAuthenticationState"

interface Props {}

const VNZAuthenticationFlow: React.FC<Props> = () => {
  const { startAuthentication, hasError, error } = useVNZAuthentication()
  const {
    state: { isAuthenticating },
  } = useVNZAuthenticationState()
  const { t } = useTranslation()

  return (
    <Flex
      flex={1}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={4}
    >
      <Image
        src={withPrefix("images/cloud-providers/vnz/logo_verizon.svg")}
        alt="VNZ Logo"
        height="28px"
        mb={6}
      />
      <Text>Add photos from Verizon Cloud</Text>
      <Button
        colorScheme="primary"
        className="VNZ Authentication Button"
        onClick={startAuthentication}
        isLoading={isAuthenticating}
      >
        {t(
          "components.cloudProvider.vnz.authentication.VNZAuthenticationFlow.ConnectVerizonCloud"
        )}
      </Button>
      {hasError && <Text color="red.500">{error}</Text>}
    </Flex>
  )
}

export default VNZAuthenticationFlow
